export default __webpack_public_path__ + "static/media/JungleSwap-screenshot-desktop.372f510d.png";